
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SingleTransactionHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transaction_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID4"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"single_transaction_history"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transaction_id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrderReceipt"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserOrderReceipt"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pair"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"img"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"proceeds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fee_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"submitted_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completed_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"order_fills"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filled_base_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"filled_quote_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"asset_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"trade_type"},"arguments":[],"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FracPackReceipt"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FracPackReceipt"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DropReceipt"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropReceipt"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CirclePaymentReceipt"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CirclePaymentReceipt"},"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"payment_updated_at"},"name":{"kind":"Name","value":"updated_at"},"arguments":[],"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CircleWithdrawalReceipt"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CircleWithdrawalReceipt"},"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"withdrawal_updated_at"},"name":{"kind":"Name","value":"updated_at"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":1222}};
    doc.loc.source = {"body":"#import \"@/graphql/fragments/TransactionHistory/UserOrderReceipt.gql\"\n#import \"@/graphql/fragments/TransactionHistory/FracPackReceipt.gql\"\n#import \"@/graphql/fragments/TransactionHistory/DropReceipt.gql\"\n#import \"@/graphql/fragments/TransactionHistory/CirclePaymentReceipt.gql\"\n#import \"@/graphql/fragments/TransactionHistory/CircleWithdrawalReceipt.gql\"\n\nquery SingleTransactionHistory($transaction_id: UUID4!) {\n  current_user {\n    single_transaction_history(transaction_id: $transaction_id) {\n      ... on UserOrderReceipt {\n        ... UserOrderReceipt\n        id\n        pair {\n          img\n        }\n        proceeds\n        fee_amount\n        submitted_time\n        completed_time\n        order_fills {\n          filled_base_amount\n          filled_quote_amount\n          asset_price\n          date\n        }\n        trade_type\n      }\n\t\t\t... on FracPackReceipt {\n        ... FracPackReceipt\n      }\n      ... on DropReceipt {\n        ... DropReceipt\n      }\n      ... on CirclePaymentReceipt {\n        ... CirclePaymentReceipt,\n        payment_updated_at: updated_at\n      }\n      ... on CircleWithdrawalReceipt {\n        ... CircleWithdrawalReceipt\n        withdrawal_updated_at: updated_at\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/TransactionHistory/UserOrderReceipt.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/TransactionHistory/FracPackReceipt.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/TransactionHistory/DropReceipt.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/TransactionHistory/CirclePaymentReceipt.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/TransactionHistory/CircleWithdrawalReceipt.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["SingleTransactionHistory"] = oneQuery(doc, "SingleTransactionHistory");
        
